const CONFIG = {
  API_URL: 'https://api.bandara.ch/api',
  ...(window.APP_CONFIG || {})
}

export default CONFIG



// WEBPACK FOOTER //
// ./src/config.js